import getNumberValues from './getNumberValues.js';
function getFirstNumberValue(sequence, key) {
    const values = getNumberValues(sequence[key]);
    return values ? values[0] : null;
}
export { getFirstNumberValue };
